import React, { Component, Fragment } from 'react';
import b from 'b_';
import { inject, observer } from 'mobx-react';
import ConsoleStore from '../../stores/ConsoleStore';
import EnvStore from '../../stores/EnvStore';
import PolicyMigrationStore from '../../stores/PolicyMigrationStore';
import ConsoleUL from '../ConsoleUL/ConsoleUL';
import { Card, FTBody, Page } from '../Fuse';
import FuseButton from '../FuseControls/FuseButton';
import Icon from '../Icon/Icon';
import PolicyMigrationModal from './PolicyMigrationModal';
/* eslint-disable import/no-webpack-loader-syntax,import/no-unresolved */
import tapPng from '!!file-loader!./tap.png';
import nonTapPng from '!!file-loader!./non-tap.png';
import { ROLE_READ_ONLY } from '../../stores/Administrators/AdministratorModalStore';
/* eslint-enable */
import './PolicyMigrationPage.css';

const block = b.lock('PolicyMigrationPage');

class PolicyMigrationPage extends Component {
    static propTypes = {
        env: EnvStore.PropType.isRequired,
        console: ConsoleStore.PropType.isRequired,
        policyMigration: PolicyMigrationStore.PropType.isRequired
    };

    static STEP_COPY = {
        1: <Fragment><b>Step 1: Review Your Policies [Legacy] Configurations</b> -
            New Policies are Inactive and hidden on the Navigation bar</Fragment>,
        // eslint-disable-next-line max-len
        2: <Fragment><b>Step 2: Configure and Test New Policies on Select Users</b> -
            New Policies [Prioritized] for added Browsing Roles users only</Fragment>,
        3: <Fragment><b>Step 3: Edit and Enable the Default Browsing Role</b> -
            Policies [Legacy] become Inactive and New Policies become Active for All Users</Fragment>,
        4: <Fragment><b>Step 4: Hide Policies [Legacy] on the Navigation Bar</b> –
            Migration Complete</Fragment>
    }

    renderStep = (step) => {
        const { console } = this.props;
        const activeStep = PolicyMigrationStore.stepNumberFromString(console.policyMigrationStep);
        const active = activeStep === step;

        return <div className={block('Step')} key={step}>
            <div className={block('Step__Icon')}>
                {active || (step < activeStep)
                    ? <Icon type="check_circle_rounded" className={block('Step__Check', { active })}/> :
                    <div className={block('Step__Number')}>{step}</div>
                }
            </div>
            <FTBody className={block('Step__Copy', { active })}>{PolicyMigrationPage.STEP_COPY[step]}</FTBody>
        </div>;
    }

    renderSteps() {
        return <div>
            {[1, 2, 3, 4].map(this.renderStep)}
        </div>;
    }

    renderOverview() {
        const { env, console } = this.props;
        const hasBrowserIsoWithUrlFlagOrTap = (console.hasBrowserOrEmailLicense() && console.urlIsolationProductEnabled)
            || console.hasTapUrlIsolationLicense();

        return <Card title="Overview: New Policies Migration">
            <FTBody>
                This section provides controls to help existing customers to convert their existing Policies [Legacy]
                into the New Policies structure. You will update your existing Policies [Legacy] in the New Policies
                structure by completing all migration steps one at a time.
            </FTBody>
            <div className={block('OverviewDetailed')}>
                <div className={block('OverviewDetailed__Text')}>
                    <FTBody>New Policies enhanced capabilities include:</FTBody>
                    <ConsoleUL>
                        <li>
                            <FTBody>
                                <span className={block('Header')}>Enable Uploads/Downloads </span>
                                for specific users and sites (Browser/Email Isolation licenses only).
                            </FTBody>
                        </li>
                        <li>
                            <FTBody className={block('Header')}> Create Rules with defined Match Criteria</FTBody>
                            <ul className={block('SecondaryUL')}>
                                <li> Exclusion Rule – send a URL to the user’s native browser. </li>
                                {hasBrowserIsoWithUrlFlagOrTap
                                    ? <li> Redirect Rule – send a URL to Isolation. </li>
                                    : null}
                                <li> Content Rule – enforce specific file, content,
                                    and scan settings to an Isolated URL. </li>
                            </ul>
                        </li>
                        <li>
                            <FTBody className={block('Header')}>Create Custom Match Criteria Elements</FTBody>
                            <ul className={block('SecondaryUL')}>
                                <li> Browsing Roles – define user sets by their emails and/or User Groups. </li>
                                <li> Custom Categories - create custom lists of URLs. </li>
                            </ul>
                        </li>
                        <li>
                            <FTBody>
                                <span className={block('Header')}>Access Codes are no longer required. </span>
                                You can now match Rules to specific Browsing Roles.
                            </FTBody>
                        </li>
                    </ConsoleUL>
                    <FTBody>
                        Because the New Policies structure is modular, it provides you with greater flexibility and
                        more granular control when designing and implementing your security strategies.
                        For each Isolation request, the system will enforce a new Policy/Rule.
                    </FTBody>
                    <FTBody className={block('SmallShrift')}>
                        For a comprehensive overview on how to use all Console features,
                        please refer to the latest Administration Guide.
                    </FTBody>
                </div>
                {!env.screen.isMobile && !env.screen.isTablet
                    ? <img
                        alt="New menu"
                        src={hasBrowserIsoWithUrlFlagOrTap ? tapPng : nonTapPng}
                        className={block('OverviewDetailed__Image')}
                    />
                    : null}
            </div>
        </Card>;
    }

    openModal = () => {
        const { policyMigration, console } = this.props;
        const step = PolicyMigrationStore.stepNumberFromString(console.policyMigrationStep);

        policyMigration.activeStep.setValue(step);
        policyMigration.viewedStep.setValue(step);
        policyMigration.modalIsOpen.setValue(true);
    }

    render() {
        const readOnly = this.props.console.authority === ROLE_READ_ONLY.value;

        return <Page title="Product Settings - New Policies Migration" className={block()}>
            <Card title="New Policies Migration"
                titleAction={!readOnly ? <FuseButton
                    color="blue"
                    icon="edit"
                    onClick={this.openModal}
                    disabled={false}
                >Edit</FuseButton> : null}
            >
                {this.renderSteps()}
            </Card>
            {this.renderOverview()}
            <PolicyMigrationModal />
        </Page>;
    }
}

export default inject('policyMigration', 'console', 'env')(observer(PolicyMigrationPage));
